var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWirelessEarphones = function SvgWirelessEarphones(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wirelessEarphones_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#wirelessEarphones_svg__b)",
    d: "M4.835 11.416a2.695 2.695 0 0 1 0-5.39h10.33a2.695 2.695 0 1 1 0 5.39"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C09C6B",
    d: "M15.983 6.153a2.695 2.695 0 0 1-2.053 4.44H3.6q-.43-.001-.818-.127c.494.582 1.23.95 2.053.95l5.165.412 5.164-.411a2.696 2.696 0 0 0 .819-5.264"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#957C5B",
    d: "M12.236 11.417H7.763v-.768c0-.395.321-.716.717-.716h3.04c.396 0 .716.32.716.716z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#957C5A",
    d: "M7.763 10.594v.823l2.237.411 2.236-.411v-.823z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#wirelessEarphones_svg__c)",
    d: "M14.736 19.818H5.264a3.74 3.74 0 0 1-3.739-3.738v-3.476c0-.656.532-1.187 1.188-1.187h14.574c.656 0 1.188.531 1.188 1.187v3.476a3.74 3.74 0 0 1-3.74 3.738"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C09C6B",
    d: "M17.287 11.417h-.104q.056.172.057.364v3.475a3.74 3.74 0 0 1-3.739 3.74H4.03c-.5 0-.977-.1-1.414-.278.677.68 1.614 1.1 2.649 1.1h9.472a3.74 3.74 0 0 0 3.738-3.739v-3.475c0-.656-.531-1.187-1.187-1.187"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CEAD84",
    d: "M12.247 17.62H7.753a1.05 1.05 0 0 1 0-2.1h4.494a1.05 1.05 0 0 1 0 2.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BF9B6F",
    d: "M12.247 15.52h-.004q.024.11.025.227c0 .58-.47 1.05-1.05 1.05h-4.49c.103.47.523.823 1.025.823h4.494a1.05 1.05 0 1 0 0-2.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.888 13.945a.6.6 0 0 0 .593-.608.6.6 0 0 0-.593-.609.6.6 0 0 0-.592.609.6.6 0 0 0 .592.608"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E1C4",
    d: "M3.36 3.849s.238 1.764 1.711 4.324c.099.171.287.227.438.128l.62-.405c.173-.113.232-.384.127-.588-.344-.668-1.014-2.106-1.074-3.261zM17.583 3.849s-.23 1.764-1.64 4.324c-.095.171-.275.227-.42.128l-.593-.405c-.167-.113-.223-.384-.123-.588.33-.668.972-2.106 1.029-3.261z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#wirelessEarphones_svg__d)",
    d: "M7.955.512H7.59a.37.37 0 0 0-.368.368.057.057 0 0 1-.1.038C6.903.677 6.27.182 4.789.182c-1.96 0-2.193 1.382-2.193 1.938 0 .557.062 2.558 2.313 2.558 1.482 0 2.016-.5 2.207-.842.03-.052.107-.03.107.028v.343c0 .203.165.368.368.368h.365c.86 0 1.557-.697 1.557-1.557v-.95c0-.86-.698-1.556-1.557-1.556"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0A17A",
    d: "M7.955.512H7.59a.37.37 0 0 0-.368.368.057.057 0 0 1-.1.038l-.007 2.918c.029-.052.107-.031.107.028v.343c0 .203.165.368.368.368h.365c.86 0 1.556-.697 1.556-1.557v-.95c0-.86-.697-1.556-1.556-1.556"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#wirelessEarphones_svg__e)",
    d: "M13.193.512h.364c.204 0 .369.165.369.368 0 .052.064.077.1.038.22-.241.852-.736 2.334-.736 1.959 0 2.193 1.382 2.193 1.938 0 .557-.062 2.558-2.314 2.558-1.482 0-2.015-.5-2.207-.842-.028-.052-.106-.03-.106.028v.343a.37.37 0 0 1-.369.368h-.364c-.86 0-1.557-.697-1.557-1.557v-.95c0-.86.697-1.556 1.557-1.556"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0A17A",
    d: "M13.193.512h.364c.204 0 .369.165.369.368 0 .052.064.077.1.038l.007 2.918c-.03-.052-.107-.031-.107.028v.343a.37.37 0 0 1-.369.368h-.364c-.86 0-1.557-.697-1.557-1.557v-.95c0-.86.697-1.556 1.557-1.556"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "wirelessEarphones_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-9.68619 4.74165 -4.2347 -8.6506 11.24 6.658)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBB59A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D59A4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "wirelessEarphones_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(144.717 3.696 8.004)scale(12.7936 13.6426)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D59A4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "wirelessEarphones_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.2619 3.955 -4.4598 -4.80587 6.599 .71)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D59A4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "wirelessEarphones_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.26192 3.95497 -4.45976 4.8059 14.55 .71)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D59A4F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "wirelessEarphones_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.182.182h19.636v19.636H.182z"
  })))));
};
export default SvgWirelessEarphones;